import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import QuickbooksContainer from "../../containers/accounting/Quickbooks";
import {gridMargin} from "./general";


class FMPQuickbooksItemSelect extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		const {quickbooksItems, searchQuickbooksItems} = this.props;
		if (_.isEmpty(quickbooksItems)) {
			searchQuickbooksItems({
				params : {}
			});
		}
	}

	render () {
		const {
			label, value, path, onChange,
			error, helpText, md, readOnly,
			quickbooksItems,
		} = this.props;

		if (!quickbooksItems) {
			return (<Grid spacing={2} container>
				<Grid item xs={12} md={md}>
					<Select
						value={value}
						input={<Input id={path} readOnly={readOnly} />}
					>
						<MenuItem key={'loading_quickbooks_accounts'} value={'loading'} disabled>
							Loading accounts from quickbooks...
						</MenuItem>
					</Select>
				</Grid>
			</Grid>);
		}

		const quickbooksItemOptions = quickbooksItems.reduce((result, quickbooksItem) => {
			const { quickbooksItemId, Name, Description, ParentRef} = quickbooksItem;

			let display = `${Name} - ${Description} (${quickbooksItemId})`;
			if (ParentRef) {
				display = (<div style={{paddingLeft:20}}>{display}</div>);
			}

			result.push({
				sortValue : Name,
				value : quickbooksItemId,
				display,
			});
			return result;
		}, []);

		const hasError = !!error;
		const _onChange = event => {
			onChange(event.target.value, path);
		};

		return (<Grid spacing={2} container >
			<Grid item xs={12} md={md} style={gridMargin}>
				<FormControl fullWidth={true} error={hasError}>
					<InputLabel htmlFor={path}>{label}</InputLabel>
					<Select
						value={value}
						onChange={_onChange}
						input={<Input id={path} readOnly={readOnly} />}
					>
						{_.sortBy(quickbooksItemOptions, 'sortValue').map(quickbooksItemOption => {
							const { display, value } = quickbooksItemOption;
							return (
								<MenuItem key={value} value={value}>
									{display}
								</MenuItem>
							);
						})}
					</Select>
					{hasError && <FormHelperText>{error}</FormHelperText>}
					{(helpText && !hasError) && <FormHelperText>{helpText}</FormHelperText>}
				</FormControl>
			</Grid>
		</Grid>);
	}
}

FMPQuickbooksItemSelect.propTypes = {
	label : PropTypes.string,
	value :	PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error : PropTypes.string,

	searchQuickbooksItems : PropTypes.func,
	quickbooksItems : PropTypes.array,

	md : PropTypes.number,
	helpText : PropTypes.string,
	readOnly : PropTypes.bool,
};

FMPQuickbooksItemSelect.defaultProps =  {
	helpText : 'Only showing accounts marked as an "Expense"'
};

export default _.flow([
	QuickbooksContainer,
])(FMPQuickbooksItemSelect);
